// @flow

import { hasKey } from 'helpers';
import useUserProfile from './useUserProfile';

type useAccessProps = {
  type?: 'app' | 'apps' | 'tab' | 'tabs' | 'feature',
  app?: 'clients' | 'myCompany' | 'myDashboard' | 'newsfeed' | 'partnerProfile' | 'phishing' | 'user' | string,
  tab?: string,
  feature?: string,
  merger?: Object
};

function useAccess({ type = 'app', app, tab, feature, merger = {} }: useAccessProps): Object {
  const profile = useUserProfile();

  if (!profile) return false;

  const { apps, features } = profile.access;

  switch (type) {
    case 'app': {
      if (app) return hasKey(apps, app);
      return apps;
    }

    case 'tab': {
      return tab && apps[tab];
    }

    case 'tabs': {
      const newAccess = app ? apps[app] : {};
      return { ...newAccess, ...merger };
    }

    case 'feature': {
      return feature ? features[feature] : features;
    }

    default: {
      return false;
    }
  }
}

export default useAccess;
